// Prevent Multiple Clicks on Contact Form 7 Submissions
jQuery(document).on('click', '.wpcf7-submit', function(e) {
    if( jQuery('.ajax-loader').hasClass('is-active') ) {
         e.preventDefault();
         return false;
    }
});